import React, {Component} from "react";
import PropTypes from "prop-types";
import {FieldTitle} from "admin-on-rest";
import TimePicker from "material-ui/TimePicker";

export const datify = input => {
  if (!input) {
    return null;
  }

  const date = input instanceof Date ? input : new Date(input);
  // if (isNaN(date)) {
  //   throw new Error(`Invalid date: ${input}`);
  // }

  return date;
};

class TimeInput extends Component {
  state = {
    value: ""
  };

  componentDidMount() {
    const timeInput = {...this.props.input}
    if (timeInput.name === "working_hours.regular.start"
    || timeInput.name === "working_hours.regular.end"
    || timeInput.name === "working_hours.saturday.start"
    || timeInput.name === "working_hours.saturday.end"
    || timeInput.name === "working_hours.sunday.start"
    || timeInput.name === "working_hours.sunday.end") {
      if (timeInput.value && timeInput.value.length < 6) {
        const time = timeInput.value.split(':');
        const hour = time[0];
        const minutes = time[1];
        timeInput.value = new Date(2007, 11, 5, hour, minutes, 0).toISOString();
        this.setState({value: timeInput.value});
      } else if (timeInput.value && timeInput.value instanceof Date) return this.setState({value: this.props.input.value});
    }
  }

  onChange = (_, time) => {
    this.props.input.onChange(time);
    this.setState({value: time});
    this.props.input.onBlur();
  };

  onBlur = () => {};

  onDismiss = () => this.props.input.onBlur();

  render() {
    const {
      elStyle,
      input,
      isRequired,
      label,
      meta,
      options,
      source,
      resource,
      timeFormat,
      defaultTime,
      working_hours
    } = this.props;
    if (typeof meta === "undefined") {
      throw new Error(
        "The TimeInput component wasn't called within a redux-form <Field>. Did you decorate it and forget to add the addField prop to your component? See https://marmelab.com/admin-on-rest/Inputs.html#writing-your-own-input-component for details."
      );
    }
    const {touched, error} = meta;

    return (
      <TimePicker
        {...input}
        errorText={touched && error}
        floatingLabelText={
          <FieldTitle
            label={label}
            source={source}
            resource={resource}
            isRequired={isRequired}
          />
        }
        defaultTime={defaultTime}
        format={timeFormat ? timeFormat : "24hr"}
        container="inline"
        autoOk
        value={working_hours ? datify(this.state.value) : datify(input.value)}
        onChange={this.onChange}
        onBlur={this.onBlur}
        onDismiss={this.onDismiss}
        style={elStyle}
        {...options}
        ref={`${this.props.source}.timePicker`}
      />
    );
  }
}

TimeInput.propTypes = {
  addField: PropTypes.bool.isRequired,
  elStyle: PropTypes.object,
  input: PropTypes.object,
  isRequired: PropTypes.bool,
  label: PropTypes.string,
  meta: PropTypes.object,
  options: PropTypes.object,
  resource: PropTypes.string,
  source: PropTypes.string,
  labelTime: PropTypes.string
};

TimeInput.defaultProps = {
  addField: true,
  options: {}
};

export default TimeInput;



// WEBPACK FOOTER //
// ./src/components/CRM/TimeInput.js